<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>ユーザ ＞ {{ $t(this.FormTitle) }}</strong>
        </h5>
        <div v-if="this.userForm.userid">
          <h5 class="vue-title">
            <strong>ID : {{ this.userForm.userid }}</strong>
          </h5>
        </div>

        <b-form class="formTextSize" @submit.prevent="userFormSubmit">

          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("SURNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.last_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.last_name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("NAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.first_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.first_name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("SURNAME") }} ( {{ $t("HIRAGANA") }})</span>
                <b-form-input
                  v-model.trim="$v.userForm.furigana_last_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.furigana_last_name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("NAME") }} ( {{ $t("HIRAGANA") }})</span>
                <b-form-input
                  v-model.trim="$v.userForm.furigana_first_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.furigana_first_name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("BIRTHDATE") }}
                </span>
                <date-picker
                  :lang="lang"
                  class="datePickerCss custom-date-picker"
                  :disabled-date="notBeforeDate"
                  placeholder="YYYY-MM-DD"
                  v-model.trim="$v.userForm.date_of_birth.$model"
                  :editable="true"
                  format="YYYY-MM-DD"
                  valuetype="DD/MM/YYYY"
                  :default-value="
                    new Date().setDate(new Date().getDate() - 6574)
                  "
                ></date-picker>

                <show-errors :control="$v.userForm.date_of_birth" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("EMAIL") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.email.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.email" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PHONENUMBER") }}
                </span>
                <b-form-input
                  @keypress="isNumberValidatorphone($event)"
                  v-model.trim="$v.userForm.contact_no.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.MaxPhone"
                ></b-form-input>
                <show-errors :control="$v.userForm.contact_no" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("POSTALCODE") }}
                </span>
                <b-form-input
                  @keypress="isNumberValidatorPost($event)"
                  @blur="checkPostalCode"
                  v-model.trim="$v.userForm.postal_code.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.postalCode"
                ></b-form-input>
                <show-errors :control="$v.userForm.postal_code" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PREFECTURES") }}
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.prefecture.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.prefecture" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CITY") }}
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.city.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.city" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("STREETADDRESS") }}
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.street_address.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.street_address" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("BUILDINGNAME") }}</span>
                <b-form-input
                  v-model.trim="$v.userForm.building_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.building_name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="3">
              <b-row>
                <b-col sm="8" >
                  <b-form-group id="addressField" label-for="input-1" class="bottom-margin">
                    <span>
                      {{ $t("GENDER") }}
                    </span>
                    <b-row>
                      <b-col sm="4"></b-col>

                      <b-form-group >
                        <b-form-radio
                          v-model="this.userForm.gender"
                          v-model.trim="$v.userForm.gender.$model"
                          name="some-radios"
                          value="female"
                        >
                          <div class="checkBoxText">{{ $t("FEMALE") }}</div>
                        </b-form-radio>
                        <b-form-radio
                          v-model="this.userForm.gender"
                          v-model.trim="$v.userForm.gender.$model"
                          name="some-radios"
                          value="male"
                        >
                          <div class="checkBoxText">{{ $t("MALE") }}</div>
                        </b-form-radio>
                        <b-form-radio
                          v-model="this.userForm.gender"
                          v-model.trim="$v.userForm.gender.$model"
                          name="some-radios"
                          value="other"
                        >
                          <div class="checkBoxText">{{ $t("OTHER") }}</div>
                        </b-form-radio>
                        <b-form-radio
                          v-model="this.userForm.gender"
                          v-model.trim="$v.userForm.gender.$model"
                          name="some-radios"
                          value=null
                        >
                          <div class="checkBoxText">{{ $t("NO_ANSWER") }}</div>
                        </b-form-radio>
                      </b-form-group>
                      <show-errors :control="$v.userForm.gender" :field="$t('MANDATORY')" />
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("UNIQUENUMBER") }}</span>
                <b-form-input
                  id="name"
                  v-model.trim="$v.userForm.patient_id.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.patient_id.name" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("PATIENT_VR_ID") }}</span>
                <b-form-input
                  v-model.trim="$v.userForm.vr_id.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.vr_id" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <strong>サービス</strong>
            </b-col>
          </b-row>
          <hr />
          <div :key="service" v-for="service in serviceGroupBY">
            <b-row>
              <b-form-group>
                <template v-slot:label>
                  <b-form-checkbox
                    aria-describedby="flavours"
                    aria-controls="flavours"
                    v-model="selectedCkt"
                    disabled
                  >
                    <div class="checkBoxText">{{ service.key }}</div>
                  </b-form-checkbox>
                </template>
                <b-form-checkbox-group
                  id="flavors"
                  v-model.trim="$v.userForm.service_ids.$model"
                  name="flavors"
                  class="ml-4"
                  aria-label="Individual flavours"
                  stacked
                >
               <!-- service list -->
                  <table>
                  <th scope="col"></th>
                 <th scope="col"></th>
                    <tr v-for="item in service.list" v-bind:key="item.id">
                      <td style="padding:5px 10px">
                        <b-form-checkbox disabled :value="item.id">
                          <div class="checkBoxText">{{ item.name }}</div>
                        </b-form-checkbox>
                      </td>
                      <td>
                        <img :src="item.icon" width="20px" alt />
                      </td>
                    </tr>
                  </table>
                </b-form-checkbox-group>
              </b-form-group>
            </b-row>
          </div>

          <b-row>
            <b-col md="12" class="text-center">
              <b-button
                class="btn btn-secondary formTextSizeBlack mr-2"
                to="/user"
              >{{ $t("CANCEL") }}</b-button>
              <button class="btn btn-primary formTextSizeBlack" type="submit">{{ $t("ADDTO") }}</button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import ShowErrors from "@/components/ShowErrors";
import {
  required,
  minLength,
  helpers
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import {
  isNumberValidator,
  isNumberValidatorphone,
  phoneDigitValidation
} from "@/shared/utils.js";
import { CONSTANTS } from "@/shared/utils";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

import {
  CREATE_PATIENT_DETAILS,
  GET_PATIENT_DETAILS,
  EDIT_PATIENT_DETAILS,
  GET_ALL_SERVICE_NO_PAGI
} from "@/store/actions.type";

import _ from "lodash";

const vrIdRegex = helpers.regex("vrIdRegex", /^[0-9A-Za-z\-]+$/)
const postalCodeRegex = helpers.regex("postalCodeRegex", /^[\d]{3}-?[\d]{4}$/)
// Vuelidateのemailバリデーション(v0.7.6)の正規表現が`A-z`という記述をしていることにより、RFC準拠の場合弾くべき文字が混ざっているため暫定的にカスタムバリデーションを用いる
const emailRegexForCreateUserInfo = helpers.regex("emailRegexForCreateUserInfo", /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i)

export default {
  name: "add-partner",
  components: { ShowErrors, DatePicker },

  data: function() {
    return {
      /* date picker lang text */
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"]
        },
        monthBeforeYear: false
      },
      /* Disable dates in date picker to not select furure dates  */
      notBeforeDate(date) {
        return date > new Date().setDate(new Date().getDate() - 6575);
      },
      CONSTANTS: CONSTANTS /* Import constants to this component */,
      selectedCkt: true,
      isNumberValidator: isNumberValidator,
      isNumberValidatorphone: isNumberValidatorphone,
      flavours: [],
      selected: [],
      allSelected: "name",
      FormTitle: "",
      /* User form model */
      userForm: {
        email: "",
        gender: null,
        date_of_birth: null,
        furigana_last_name: "",
        first_name: "",
        last_name: "",
        furigana_first_name: "",
        contact_no: "",
        building_name: "",
        street_address: "",
        prefecture: "",
        city: "",
        postal_code: "",
        service_ids: [],
        userForm: "",
        patient_id: "",
        vr_id: "",
      },
      serviceList: [],
      serviceGroupBY: []
    };
  },
  /*validation for the Each fields in From */
  validations: {
    userForm: {
      email: { required, emailRegexForCreateUserInfo },
      gender: {},
      date_of_birth: {},
      furigana_last_name: {},
      first_name: { required },
      last_name: { required },
      furigana_first_name: {},
      contact_no: { phoneNumber: minLength(10) },
      building_name: {},
      street_address: {},
      prefecture: {},
      city: {},
      postal_code: { postalCodeRegex },
      service_ids: { required },
      patient_id: {},
      vr_id: { vrIdRegex }
    }
  },
  watch: {
    /* On select parent item select all child rows checkbox */
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.allSelected = false;
      } else if (newVal.length === this.flavours.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    }
  },
  computed: {
    ...mapGetters(["serviceCategoryMaster"])
  },
  methods: {
    /**
     * Sumbitting the Filled Form
     * Input @param {object} object this.userForm object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */

    async userFormSubmit() {
      this.$v.$touch();
      if (!this.$v.userForm.$invalid) {
        if(this.userForm.contact_no) {
          if (phoneDigitValidation(this.userForm.contact_no) === true) {
            this.$toast.error({
              message: this.$t("INVALIDPHONENO")
            });
            return;
          }
        };
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        /* validating date of birth */
        if (this.notBeforeDate(this.userForm.date_of_birth)) {
          this.$toast.error({
            message: this.$t("SELECTPROPERDATE")
          });
          this.isLoading.hide();
          return;
        }
        if (this.userForm.date_of_birth !== null) {
          this.userForm.date_of_birth = moment(this.userForm.date_of_birth).format(
            "YYYY-MM-DD"
          );
        }
        let payload = Object.assign({}, this.userForm);
        /* if param id exist call edit API else create API */
        if (_.get(this.params, "id", 0)) { // ユーザー情報更新
          payload["id"] = _.get(this.params, "id", 0);
          payload["_method"] = "PUT";

          let response = await this.$store.dispatch(EDIT_PATIENT_DETAILS, payload)
          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "user"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        } else { // ユーザー情報作成
          /*chagen date format before calling API */
          let createFromPayload = Object.assign({}, this.userForm);

          let response = await this.$store.dispatch(CREATE_PATIENT_DETAILS, createFromPayload);
          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "user"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        }
      }
    },
    toggleAll(checked) {
      this.userForm.service_ids = checked
        ? _.map(this.serviceGroupBY, item => item.id)
        : [];
    },

    /* Remove digit when user removing dash */
    removeDash(evt) {
      if (this.userForm.postal_code.length == 4) {
        this.userForm.postal_code = this.userForm.postal_code.substring(
          0,
          this.userForm.postal_code.length - 1
        );
      }
    },
    /*Postal code validating. Adding - after */
    isNumberValidatorPost(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57)
      ) {
        evt.preventDefault();
      }
      if (this.userForm.postal_code.length == 3) {
        this.userForm.postal_code = this.userForm.postal_code + "-";
      } else if (this.userForm.postal_code.length < 3) {
        this.userForm.postal_code = this.userForm.postal_code.replace("-", "");
      }
    },
    /* On focus out do postal code format */
    checkPostalCode() {
      let temp = this.userForm.postal_code.replace("-", "");
      if (temp.length > 3) {
        let startString = temp.slice(0, 3);
        let endString = temp.slice(3, 7);
        this.userForm.postal_code = startString + "-" + endString;
      }
    }
  },
  async created() {
    this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
    let data = await this.$store.dispatch(GET_ALL_SERVICE_NO_PAGI, {
      field: "id",
      sort: "desc"
    });
    this.isLoading.hide();
    /* service list data formatting by group by parent name and removing parent name which is null.  */
    this.serviceList = data.categories;
    let temp = this.serviceList;
    this.flavours = _.filter(temp, item => item.parent_name != null);
    let serviceGroupBYParent = _.groupBy(temp, item => item.parent_name);

    serviceGroupBYParent = _.omit(serviceGroupBYParent, ["null"]);
    let constractedList = [];
    _.forOwn(serviceGroupBYParent, (value, key) => {
      constractedList.push({ key: key, list: serviceGroupBYParent[key] });
      this.userForm.service_ids = _.concat(
        this.userForm.service_ids,
        _.map(serviceGroupBYParent[key], item => item.id)
      );
    });
    this.serviceGroupBY = constractedList;

    this.params = this.$route.params;
    this.FormTitle = "CREATE";
    /* when user redirect from edit button. Binding data to user modal */
    if (_.get(this.params, "id", 0)) {
      this.FormTitle = "EDIT";
      /* Get patient user by id and bind to user model */
      let partnerDetails =  await this.$store
        .dispatch(GET_PATIENT_DETAILS, {
          id: _.get(this.params, "id", 0)
        })
      if (_.get(partnerDetails, "patient_details", 0)) {
        let dateOfBirth = _.get(partnerDetails, "patient_details.date_of_birth", null);
        if (dateOfBirth !== null) {
          dateOfBirth = new Date(dateOfBirth);
        }

        this.userForm = {
          first_name: _.get(partnerDetails, "patient_details.first_name", ""),
          last_name: _.get(partnerDetails, "patient_details.last_name", ""),
          gender: _.get(partnerDetails, "patient_details.gender", null),
          email: _.get(partnerDetails, "patient_details.email", ""),
          furigana_last_name: _.get(
            partnerDetails,
            "patient_details.furigana_last_name",
            ""
          ),
          furigana_first_name: _.get(
            partnerDetails,
            "patient_details.furigana_first_name",
            ""
          ),
          date_of_birth: dateOfBirth,
          building_name: _.get(
            partnerDetails,
            "patient_details.address.building_name",
            ""
          ),
          street_address: _.get(
            partnerDetails,
            "patient_details.address.street_address",
            ""
          ),
          prefecture: _.get(partnerDetails, "patient_details.address.prefecture", ""),
          city: _.get(partnerDetails, "patient_details.address.city", ""),
          postal_code: _.get(
            partnerDetails,
            "patient_details.address.postal_code",
            ""
          ),
          contact_no: _.get(partnerDetails, "patient_details.contact_no", ""),
          userid: _.get(partnerDetails, "patient_details.user.userid", ""),
          service_ids: _.map(this.flavours, item => item.id),
          patient_id: _.get(partnerDetails, "patient_details.patient_id", ""),
          vr_id: _.get(partnerDetails, "patient_details.vr_id", "")
        };
      }
    }
  }
};
</script>
<style scoped>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
.checkBoxText {
  margin-top: 3px;
}
.bottom-margin{
  margin-bottom:0px;
}
</style>
